import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Augustin Ursu
 * id AF35DB46-1B52-4721-8475-F3CD107325B4
 * name knife
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/knife.svg
 * tags
 */
export const KnifeIcon = createSvgIcon(<><path d="M20.62,2C23.97,7.61 12.47,20.15 12.47,20.15L9.6,17.28L4.91,22L2.77,19.86L20.62,2Z" /></>, 'KnifeIcon');
export default KnifeIcon